// Library Methods
import { useTranslation } from "react-i18next";

// Components
import { FormControlLabel, Grid } from "@mui/material";
import CustomSwitch from "../../../../../../components/UI/CustomSwitch";
import TitleWithTooltip from "../../../../../../components/UI/TitleWithTooltip";

const ToggleGrid = ({
  isActive,
  title,
  tooltip,
  checked,
  onChange,
  testId = undefined,
}) => {
  const textStyle = {
    fontSize: "14px",
    fontWeight: "normal",
    color: isActive ? "#FFF" : "#5B6D7A",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "105px",
  };
  const tooltipStyle = {
    fontSize: "14px",
    fontWeight: "normal",
    color: isActive ? "#FFF" : "#5B6D7A",
  };

  return (
    <FormControlLabel
      sx={{
        marginRight: 0,
        "& .MuiFormControlLabel-label": {
          marginLeft: "0px",
        },
      }}
      control={
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          disabled={!isActive}
          inputProps={{ "data-testid": testId }}
        />
      }
      label={
        <TitleWithTooltip
          title={title}
          tooltip={tooltip}
          titleStyle={textStyle}
          tooltipStyle={tooltipStyle}
        />
      }
    />
  );
};

const ExamCardToggles = ({
  isActive,
  optionalToggles,
  updateExamCardProperty,
  showToggles = {},
}) => {
  // internationalization
  const { t } = useTranslation();

  const {
    autoPause,
    calibration,
    encouragement,
    requiresTutorial,
    unlimitedTime,
  } = optionalToggles;

  return (
    <Grid
      display="flex"
      flexWrap="wrap"
      height={{ xs: "fit-content", sm: "76px" }}
    >
      {/* Auto-pause */}
      {showToggles.autoPause && (
        <Grid item xs={12} sm={6}>
          <ToggleGrid
            isActive={isActive}
            title={t("auto_pause")}
            tooltip={t("auto_pause_tooltip")}
            checked={(isActive && autoPause) ?? false}
            onChange={(e) =>
              updateExamCardProperty("optionalToggles", {
                ...optionalToggles,
                autoPause: e.target.checked,
              })
            }
          />
        </Grid>
      )}

      {/* Encouragement */}
      {showToggles.encouragement && (
        <Grid item xs={12} sm={6}>
          <ToggleGrid
            isActive={isActive}
            title={t("encouragement")}
            tooltip={t("encouragement_tooltip")}
            checked={(isActive && encouragement) ?? false}
            onChange={(e) =>
              updateExamCardProperty("optionalToggles", {
                ...optionalToggles,
                encouragement: e.target.checked,
              })
            }
          />
        </Grid>
      )}

      {/* Calibration */}
      {showToggles.calibration && (
        <Grid item xs={12} sm={6}>
          <ToggleGrid
            isActive={isActive}
            title={t("calibration")}
            tooltip={t("calibration_tooltip")}
            checked={(isActive && calibration) ?? false}
            onChange={(e) =>
              updateExamCardProperty("optionalToggles", {
                ...optionalToggles,
                calibration: e.target.checked,
              })
            }
          />
        </Grid>
      )}

      {/* Tutorial */}
      {showToggles.requiresTutorial && (
        <Grid item xs={12} sm={6}>
          <ToggleGrid
            isActive={isActive}
            title={t("exams_table_expand_tutorial")}
            tooltip={t("tutorial_tooltip")}
            checked={(isActive && requiresTutorial) ?? false}
            onChange={(e) =>
              updateExamCardProperty("optionalToggles", {
                ...optionalToggles,
                requiresTutorial: e.target.checked,
              })
            }
            testId="toggle-grid-tutorial"
          />
        </Grid>
      )}

      {/* Unlimited Time */}
      {showToggles.unlimitedTime && (
        <Grid item xs={12} sm={6}>
          <ToggleGrid
            isActive={isActive}
            title={t("unlimited_time")}
            tooltip={t("unlimited_time_tooltip")}
            checked={(isActive && unlimitedTime) ?? false}
            onChange={(e) =>
              updateExamCardProperty("optionalToggles", {
                ...optionalToggles,
                unlimitedTime: e.target.checked,
              })
            }
            testId="toggle-grid-unlimited-time"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ExamCardToggles;
